import { Link } from 'react-router-dom';
import { ChevronRight, Sparkles } from 'lucide-react';
import type { AskScreen } from '../domain/ask';
import { AmariMark } from './Logo';
import { PlusChip, useIsPlus } from './Plus';

/** The Ask Amari screen, remembering where the person came from (and the recipe, from a recipe). */
export function askHref(from: AskScreen, recipeId?: string): string {
  return `/ask?from=${from}${recipeId ? `&recipe=${encodeURIComponent(recipeId)}` : ''}`;
}

/** A row that opens Ask Amari: the avatar, a prompt, and "Plus" for people on the free plan. */
export function AskAmariCard({ from, title = 'Ask Amari', detail, className = '' }: { from: AskScreen; title?: string; detail: string; className?: string }) {
  const plus = useIsPlus();
  return (
    <Link to={askHref(from)} className={`tile tile-interactive flex items-center gap-3 px-4 py-3 min-h-[64px] ${className}`}>
      <AmariMark size={36} />
      <span className="flex-1 min-w-0">
        <span className="flex items-center gap-2 text-headline">{title}{!plus && <PlusChip>Plus</PlusChip>}</span>
        <span className="block text-subhead text-fg-muted truncate">{detail}</span>
      </span>
      <ChevronRight size={18} className="text-fg-muted" aria-hidden />
    </Link>
  );
}

/** A small button that opens Ask Amari, e.g. about the recipe on screen. */
export function AskAmariButton({ from, recipeId, label = 'Ask Amari' }: { from: AskScreen; recipeId?: string; label?: string }) {
  const plus = useIsPlus();
  return (
    <Link to={askHref(from, recipeId)} className="btn btn-sm btn-tonal">
      <Sparkles size={16} aria-hidden /> {label}{!plus && <PlusChip className="ml-1">Plus</PlusChip>}
    </Link>
  );
}
